module.exports = __webpack_public_path__ + "static/img/img9.52a6ee47.png";